import { dataProps, 
        imageListProps, 
        comboProductListProps, 
        styleChoiceListProps, 
        styleChoiceOptionListProps,
        fabricConsumptionProps,
        estoreVariationProps,
        customChoiceListProps,
        customChoiceOptionListProps } from './properties'

export const setTailoringMasterList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setTailoringMasterData = (state, payload) => {

    state.props = payload.response
    
    if(payload.copy) {
        state.props.image_list.forEach(element => {
            element.id = 0
        })
        state.props.combination_item_list.forEach(element => {
           // element.id = 0
        })
        state.props.style_choice_list.forEach(element => {
            element.id = 0
            element.option_list.forEach(element1 => {
                element1.id = 0
            })
        })
        state.props.custom_choice_list.forEach(element => {
            element.id = 0
        })
    } else {

        if(state.props.custom_choice_list === null || state.props.custom_choice_list.length === 0) {
            state.props.custom_choice_list = [JSON.parse(JSON.stringify(customChoiceListProps))]
        }

        if(state.props.estore_variation_list === null || state.props.estore_variation_list.length === 0) {
            state.props.estore_variation_list = [JSON.parse(JSON.stringify(estoreVariationProps))]
            state.props.estore_variation_list.forEach(element => {
                if(element.image_list.length === 0) {
                    element.image_list.push("")
                }
            })
        } else {
            state.props.estore_variation_list.forEach(element => {
                if(element.image_list.length === 0) {
                    element.image_list.push("")
                }
            })
        }
        
    }

    let key = 0
    state.props.custom_choice_list.forEach(el => {
        el.key = key
        key ++
    })

} 

// COMBINATION PROPS //
export const addNewTailoringMasterCombinationItemRow = state => {

    let key = 0
    state.props.combination_item_list.push(JSON.parse(JSON.stringify(comboProductListProps)))

    state.props.combination_item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeTailoringMasterCombinationItemRow = (state, payload) => {

    let key = 0

    state.props.delete_combination_item_list.push(state.props.combination_item_list[payload])

    state.props.combination_item_list.splice(payload, 1)

    if(state.props.combination_item_list.length === 0) {
        state.props.combination_item_list = [JSON.parse(JSON.stringify(comboProductListProps))]
    }

    state.props.combination_item_list.forEach(element => {
        element.key = key
        key ++
    })

}
// END //
export const addNewTailoringMasterEStoreVariationRow = state => {

    let key = 0
    state.props.estore_variation_list.push(JSON.parse(JSON.stringify(estoreVariationProps)))

    state.props.estore_variation_list.forEach(element => {
        element.key = key
        key ++
    })

    state.props.estore_variation_list.forEach(element => {
        if(element.image_list.length === 0) {
            element.image_list.push("")
        }
    })

}

export const removeTailoringMasterEStoreVariationRow = (state, payload) => {

    let key = 0

    state.props.estore_variation_list.splice(payload, 1)

    if(state.props.estore_variation_list.length === 0) {
        state.props.estore_variation_list = [JSON.parse(JSON.stringify(estoreVariationProps))]
    }

    state.props.estore_variation_list.forEach(element => {
        element.key = key
        key ++
    })

}
// IMAGE PROPS //
export const addNewTailoringMasterImageRow = state => {

    let key = 0
    state.props.image_list.push(JSON.parse(JSON.stringify(imageListProps)))

    state.props.image_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeTailoringMasterImageRow = (state, payload) => {

    let key = 0

    state.props.delete_image_list.push(state.props.image_list[payload])

    state.props.image_list.splice(payload, 1)

    if(state.props.image_list.length === 0) {
        state.props.image_list = [JSON.parse(JSON.stringify(imageListProps))]
    }

    state.props.image_list.forEach(element => {
        element.key = key
        key ++
    })

}
// END //

//STYLE CHOICES//
export const addNewTailoringMasterStyleChoiceRow = state => {

    let key = 0
    state.props.style_choice_list.push(JSON.parse(JSON.stringify(styleChoiceListProps)))

    state.props.style_choice_list.forEach(element => {
        element.key = key
        element.sl_no = key        
        key ++
    })

    setTimeout(() => {
        document.getElementById('style_name_'+(key-1)).focus()
    }, 300);

}

export const removeTailoringMasterStyleChoiceRow = (state, payload) => {

    let key = 0

    state.props.delete_style_choice_list.push(state.props.style_choice_list[payload])

    state.props.style_choice_list.splice(payload, 1)

    if(state.props.style_choice_list.length === 0) {
        state.props.style_choice_list = [JSON.parse(JSON.stringify(styleChoiceListProps))]
    }

    state.props.style_choice_list.forEach(element => {
        element.key = key
        element.sl_no = key
        key ++
    })

}
export const addNewStyleChoiceListOptionItemRow = (state, parent_key) => {

    let key = 0
    state.props.style_choice_list[parent_key].option_list.push(JSON.parse(JSON.stringify(styleChoiceOptionListProps)))

    state.props.style_choice_list[parent_key].option_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('style_option_'+(key-1)).focus()
    }, 300);

}

export const removeStyleChoiceListOptionItemRow = (state, payload) => {

    let key = 0

    state.props.style_choice_list[payload.parent_key].delete_option_list.push(state.props.style_choice_list[payload.parent_key].option_list[payload.key])

    state.props.style_choice_list[payload.parent_key].option_list.splice(payload.key, 1)

    if(state.props.style_choice_list[payload.parent_key].option_list.length === 0) {
        state.props.style_choice_list[payload.parent_key].option_list = [JSON.parse(JSON.stringify(styleChoiceOptionListProps))]
    }

    state.props.style_choice_list[payload.parent_key].option_list.forEach(element => {
        element.key = key
        key ++
    })

}
// END //

//CUSTOM CHOICES//
export const addNewTailoringMasterCustomChoiceRow = state => {

    let key = 0
    state.props.custom_choice_list.push(JSON.parse(JSON.stringify(customChoiceListProps)))

    state.props.custom_choice_list.forEach(element => {
        element.key = key
        element.sl_no = key        
        key ++
    })

}

export const removeTailoringMasterCustomChoiceRow = (state, payload) => {

    let key = 0

    state.props.delete_custom_choice_list.push(state.props.custom_choice_list[payload])

    state.props.custom_choice_list.splice(payload, 1)

    if(state.props.custom_choice_list.length === 0) {
        state.props.custom_choice_list = [JSON.parse(JSON.stringify(customChoiceListProps))]
    }

    state.props.custom_choice_list.forEach(element => {
        element.key = key
        element.sl_no = key
        key ++
    })

}
export const addNewCustomChoiceListOptionItemRow = (state, parent_key) => {

    let key = 0
    state.props.custom_choice_list[parent_key].style_options.push(JSON.parse(JSON.stringify(customChoiceOptionListProps)))

    state.props.custom_choice_list[parent_key].style_options.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeCustomChoiceListOptionItemRow = (state, payload) => {

    let key = 0

    state.props.custom_choice_list[payload.parent_key].style_options.splice(payload.key, 1)

    if(state.props.custom_choice_list[payload.parent_key].style_options.length === 0) {
        state.props.custom_choice_list[payload.parent_key].style_options = [JSON.parse(JSON.stringify(customChoiceOptionListProps))]
    }

    state.props.custom_choice_list[payload.parent_key].style_options.forEach(element => {
        element.key = key
        key ++
    })

}
// END //

// SIZE PROPS //
export const addNewTailoringMasterFabricConsumptionRow = state => {

    let key = 0
    state.props.fabric_consumption_list.push(JSON.parse(JSON.stringify(fabricConsumptionProps)))

    state.props.fabric_consumption_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('size_name_'+(key-1)).focus()
    }, 300);
}

export const removeTailoringMasterFabricConsumptionRow = (state, payload) => {

    let key = 0

    state.props.delete_fabric_consumption_list.push(state.props.fabric_consumption_list[payload])

    state.props.fabric_consumption_list.splice(payload, 1)

    if(state.props.fabric_consumption_list.length === 0) {
        state.props.fabric_consumption_list = [JSON.parse(JSON.stringify(fabricConsumptionProps))]
    }

    state.props.fabric_consumption_list.forEach(element => {
        element.key = key
        key ++
    })

}
// END //

export const sortStyleTemplateList = (state, payload) => {

    let key = (payload.sl_no)

    if(payload.sort == 1) {
        state.props.style_choice_list[key].sl_no = payload.sl_no+1
        state.props.style_choice_list[key+1].sl_no = payload.sl_no         
    } else if(payload.sort == 0) {
        state.props.style_choice_list[key].sl_no = payload.sl_no-1
        state.props.style_choice_list[key-1].sl_no = payload.sl_no         
    }

    state.props.style_choice_list = state.props.style_choice_list.sort( (a,b) => { 
        var x = a.sl_no < b.sl_no? -1:1; 
        return x; 
    });

}

export const resetTailoringMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringMaster/mutations.js